import env from '@/env';
import type { ResultFilter } from '../schema.graphql';

export const API_URL = env.BINOSIGHT_API_URL;

type Filters = ReadonlyArray<ResultFilter>;
type FilterMode = 'LogicalAnd' | 'LogicalOr';

function appendReportFilterQueryParameters(
    url: string,
    filters?: Filters,
    filterMode?: FilterMode,
): string {
    if (!filters?.length) {
        return url;
    }
    const filtersQuery = filters
        .map(
            ({ metaKey, metaValues }) =>
                `filters[${metaKey}]=${metaValues.join('|')}`,
        )
        .join('&');
    return `${url}&filterMode=${filterMode || 'LogicalAnd'}&${filtersQuery}`;
}

/**
 * For downloading "Project Quality Report" pdf.
 */
export const createDownloadPQRUrl = (
    projectId: string,
    surveyNumber: number,
    filters?: Filters,
    filterMode?: FilterMode,
    locale?: string,
) =>
    appendReportFilterQueryParameters(
        `${API_URL}/service/report/projectQualityReport?projectId=${projectId}&surveyNumber=${surveyNumber}&locale=${locale}`,
        filters,
        filterMode,
    );

/**
 * For downloading "Summary Project Quality Report" pdf.
 * */
export const createDownloadSummaryPQRUrl = (
    projectId: string,
    surveyNumber: number,
    filters?: Filters,
    filterMode?: FilterMode,
    locale?: string,
) =>
    appendReportFilterQueryParameters(
        `${API_URL}/service/report/summaryReport?projectId=${projectId}&surveyNumber=${surveyNumber}&locale=${locale}`,
        filters,
        filterMode,
    );

/**
 * For downloading "Feedback Report" pdf.
 */
export const createDownloadFeedbackPQRUrl = (
    projectId: string,
    surveyNumber: number,
    filters?: Filters,
    filterMode?: FilterMode,
    locale?: string,
) =>
    appendReportFilterQueryParameters(
        `${API_URL}/service/report/feedbackReport?projectId=${projectId}&surveyNumber=${surveyNumber}&locale=${locale}`,
        filters,
        filterMode,
    );

/**
 * For generating "Survey Invitation Poster" pdf.
 */
export const createDownloadSurveyInvitationPosterUrl = (
    projectId: string,
    surveyNumber: number,
    variant: 'professional-workers',
): string =>
    `${API_URL}/service/report/surveyInvitationPoster?projectId=${projectId}&surveyNumber=${surveyNumber}&variant=${variant}`;

/**
 * For downloading a data sheet
 */
export const createDownloadDataSheetUrl = (
    projectId: string,
    surveyNumber: number | string,
) =>
    `${API_URL}/service/pqi/datasheet.csv?projectId=${projectId}&surveyNumber=${surveyNumber}`;
